<!-- 印章操作组件 -->
<template>
    <div class="split-button-box"
         v-if="!seal.old">
        <el-button type="text"
                   v-if="status === 1"
                   @click.stop="doPoppWriteSeal(seal.sealData)">写入UKEY</el-button>
        <el-button type="text"
                   v-if="status === 1"
                   @click.stop="doFrozon(seal.id || seal.sealId)">冻结</el-button>
        <el-button type="text"
                   v-if="status === 4"
                   @click.stop="doUnFrozon(seal.id  || seal.sealId)">解冻</el-button>
        <el-button type="text"
                   v-if="status !== 6 && status !== 5 && status !== 3"
                   @click.stop="doLogout(seal.id  || seal.sealId)">注销</el-button>

        <!-- ukey签署 -->
        <ukey-password-sign :visible.sync="visibleUkey"
                            v-if="visibleUkey"
                            confirm-text="确定"
                            @onConfirm="doWriteUkey"></ukey-password-sign>
    </div>
</template>

<script>
import UkeyPasswordSign from '@/pages/sign/childs/ukey-password-confirm.vue';


export default {
    name: 'SealControl',
    components: { UkeyPasswordSign },
    computed: {
        status () {
            return this.seal.status || this.seal.seal_status;
        }
    },
    props: {
        seal: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data () {
        return {
            visibleUkey: false,
            sealInfo: {
                issuer: '',
                pic: '',
                struct: '',
                pin: ''
            }
        };
    },
    inject: ["app"],
    methods: {
        /**
        * 冻结印章
        * @param {String} id 印章ID
        */
        async doFrozon (id) {
            let resp, loading;
            try {
                await this.$confirm('是否确认冻结印章?', '冻结印章', {
                    type: 'warning'
                });
                loading = this.$loading({
                    text: '加载中...'
                });
                resp = await this.axios({
                    url: '/seal/operate/freeze',
                    method: 'POST',
                    params: { id }
                });
                if (resp.data.code === 0) {
                    this.$message.success('冻结成功!');
                    this.$emit('onFlesh');
                } else {
                    this.$message.success(resp.data.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        /**
         * 解冻印章
         * @param {String} id 印章ID
         */
        async doUnFrozon (id) {
            let resp, loading;
            try {
                loading = this.$loading({
                    text: '加载中...'
                });
                resp = await this.axios({
                    url: '/seal/operate/unfreeze',
                    method: 'POST',
                    params: { id }
                });
                if (resp.data.code === 0) {
                    this.$message.success('解冻成功!');
                    this.$emit('onFlesh');
                } else {
                    this.$message.success(resp.data.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }

        },

        /**
         * 注销印章
         * @param {String} id 印章ID
         */
        async doLogout (id) {
            let resp, loading;
            try {
                await this.$confirm('是否确认吊销印章?', '吊销印章', {
                    type: 'warning'
                });
                loading = this.$loading({
                    text: '加载中...'
                });
                resp = await this.axios({
                    url: '/seal/operate/destroy',
                    method: 'POST',
                    params: { id }
                });
                if (resp.data.code === 0) {
                    this.$message.success('吊销成功!');
                    this.$emit('onFlesh');
                } else {
                    this.$message.success(resp.data.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        /**
        * 写入ukey记录
        */
        async recordSealOperate () {
            try {
                await this.axios({
                    url: '/seal/operate/write',
                    method: 'POST',
                    params: { id: this.sealId }
                });
            } catch (error) {
                console.log(error);
            }
        },

        async  doPoppWriteSeal (sealData) {
            try {
                await this.$confirm('是否将此印章写入USBKey?', '写入USBKey', { type: 'warning' });
                try {
                    this.sealInfo.struct = 'MII=';
                    this.sealInfo.pic = sealData;
                    this.sealInfo.issuer = 'MII=';
                    this.visibleUkey = true;
                } catch (error) {
                    this.$message.error('服务器出错！');
                    console.log(error);
                }
            } catch (error) {
                console.log(error);
            }
        },

        /**
         * 写入UKEY
         */
        async doWriteUkey (pin) {
            let resp, loading;
            try {
                loading = this.$loading({
                    text: '正在写入Ukey...'
                });
                this.sealInfo.pin = pin;
                let data = new FormData();
                await this.app.ukey.initService(pin, false);
                const certResp = await this.app.ukey.getCert();
                const cert = encodeURIComponent(certResp.result);
                data.append('cert', cert);
                data.append('sealData', this.sealInfo.pic);
                let checkInfo = await this.axios({
                    url: '/cert/check',
                    method: 'POST',
                    data: data
                });
                checkInfo = checkInfo.data;
                if (checkInfo.code === 0) {
                    if (this.Utils.isIE()) {
                        this.sealInfo.struct = this.sealInfo.pic;
                        let issure, structData = new FormData();
                        structData.append('sealData', this.sealInfo.pic);
                        issure = await await this.axios({
                            url: '/seal/struct',
                            method: 'POST',
                            data: structData
                        });
                        issure = issure.data;
                        if (issure.code === 0) {
                            this.sealInfo.struct = this.sealInfo.pic;
                            this.sealInfo.pic = issure.pic_data;
                            this.sealInfo.issure = issure.issuer_cert;
                        } else {
                            this.$message.error(issure.message);
                            return;
                        }
                    }
                    resp = await this.app.ukey.setSeal(this.sealInfo);
                    if (resp.code === 0) {
                        this.$message.success('写入成功！');
                        if (this.Utils.isIE()) {
                            this.app.getSafeEngineInfo(pin);
                            this.recordSealOperate();
                        } else {
                            this.app.startService();
                        }
                    } else {
                        this.$message.error('写入失败！');
                    }
                } else {
                    this.$message.error(checkInfo.message);
                }
            } catch (error) {
                if (error && error.message) {
                    this.$message.error(error.message);
                }
                console.log(error);
            } finally {
                loading && loading.close();
            }
        }
    }
};
</script>

